module.exports = __webpack_public_path__ + "static/PhilDumontetHeadshot-3c6818c9059392a6917e134a6d671612.jpg";